import config from 'react-global-configuration';
import Immutable from 'immutable';
import {
  setOperationStatus,
  UI_OPERATION_STATUS_ERROR,
  UI_OPERATION_STATUS_REQUEST,
  UI_OPERATION_STATUS_SUCCESS,
} from '@uncinc/react-drupal-core';

export function unpairClient(domain, clientUid) {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;
    const endpoint = `${PATH}/remove-user-from-poh`;

    dispatch(setOperationStatus('nursePractitioner', 'unpair_client', UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(`${PATH}/rest/session/token`, { credentials: 'include' })
        .then((response) => response.text())
        .then((csrfToken) => fetch(endpoint, {
          method: 'post',
          credentials: 'include',
          body: JSON.stringify({
            client_uid: clientUid,
            domain,
          }),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
          },
        }))
        .then((response) => {
          if (!response.ok) {
            throw new Error();
          }
          dispatch(setOperationStatus('nursePractitioner', 'unpair_client', UI_OPERATION_STATUS_SUCCESS));
          dispatch(fetchClients());
        })
        .then(() => {
          resolve();
        })
        .catch((err) => {
          dispatch(setOperationStatus('nursePractitioner', 'unpair_client', UI_OPERATION_STATUS_ERROR));
          reject(err);
        });
    });
  };
}

export function inviteClient({ first_name, email_address, domain }) {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;
    const endpoint = `${PATH}/invite-client-via-mail`;

    dispatch(setOperationStatus('nursePractitioner', 'invite_client', UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(`${PATH}/rest/session/token`, { credentials: 'include' })
        .then((response) => response.text())
        .then((csrfToken) => fetch(endpoint, {
          method: 'post',
          credentials: 'include',
          body: JSON.stringify({
            first_name,
            email_address,
            domain,
          }),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
          },
        }))
        .then((response) => {
          if (!response.ok) {
            throw new Error();
          }
          dispatch(setOperationStatus('nursePractitioner', 'invite_client', UI_OPERATION_STATUS_SUCCESS));
          resolve();
        })
        .catch((err) => {
          dispatch(setOperationStatus('nursePractitioner', 'invite_client', UI_OPERATION_STATUS_ERROR));
          reject(err);
        });
    });
  };
}

export const CLIENTS_FETCHED = 'CLIENTS_FETCHED';

export function clientsFetched(data) {
  return {
    type: CLIENTS_FETCHED,
    data,
  };
}

export const CLIENT_REGISTRATIONS_LOADED = 'CLIENT_REGISTRATIONS_LOADED';

export function clientRegistrationsLoaded(data) {
  return {
    type: CLIENT_REGISTRATIONS_LOADED,
    data,
  };
}

export const CLIENT_EXERCISES_LOADED = 'CLIENT_EXERCISES_LOADED';
export function clientExercisesLoaded(data) {
  return {
    type: CLIENT_EXERCISES_LOADED,
    data,
  };
}

export const PROGRAM_LOADED = 'PROGRAM_LOADED';
export function programLoaded(data) {
  return {
    type: PROGRAM_LOADED,
    data,
  };
}

export const EXERCISE_FIELDS_LOADED = 'EXERCISE_FIELDS_LOADED';
export function exerciseFieldsLoaded(data) {
  return {
    type: EXERCISE_FIELDS_LOADED,
    data,
  };
}

export const NURSE_PRACTITIONER_INFO_LOADED = 'NURSE_PRACTITIONER_INFO_LOADED';
export function nursePractitionerInfoLoaded(data) {
  return {
    type: NURSE_PRACTITIONER_INFO_LOADED,
    data,
  };
}

export const NURSE_PRACTITIONER_UNPAIRED = 'NURSE_PRACTITIONER_UNPAIRED';
export function nursePractitionerUnpaired() {
  return {
    type: NURSE_PRACTITIONER_UNPAIRED,
  };
}

export const RESET_NURSE_PRACTITIONER = 'RESET_NURSE_PRACTITIONER';
export function resetNursePractitioner() {
  return {
    type: RESET_NURSE_PRACTITIONER,
  };
}

export const getNursePractitionerInfo = () => {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    dispatch(setOperationStatus('nursePractitioner', 'getInfo', UI_OPERATION_STATUS_REQUEST));

    fetch(`${PATH}/proxy/get-poh-information?_format=json`, {
      credentials: 'include',
    })
      .then((response) => {
        if (!response.ok) throw new Error();
        return response.json();
      })
      .then((response) => {
        dispatch(setOperationStatus('nursePractitioner', 'getInfo', UI_OPERATION_STATUS_SUCCESS));
        dispatch(nursePractitionerInfoLoaded(response));
      })
      .catch((error) => {
        dispatch(nursePractitionerInfoLoaded(null));
        dispatch(setOperationStatus('nursePractitioner', 'getInfo', UI_OPERATION_STATUS_ERROR));
      });
  };
};

export function fetchProgram(domain) {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;
    const endpoint = `${PATH}/get-program-node/${domain}`;

    dispatch(setOperationStatus('nursePractitioner', `fetchProgram-${domain}`, UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(endpoint, { credentials: 'include' })
        .then((response) => {
          if (!response.ok) {
            throw new Error();
          }
          return response.json();
        })
        .then((payload) => {
          dispatch(programLoaded({
            ...payload,
            domain,
          }));
        }).then((payload) => {
          dispatch(fetchFieldData(domain));
          dispatch(setOperationStatus('nursePractitioner', `fetchProgram-${domain}`, UI_OPERATION_STATUS_SUCCESS));
          resolve(payload);
        })
        .catch((err) => {
          dispatch(setOperationStatus('nursePractitioner', `fetchProgram-${domain}`, UI_OPERATION_STATUS_ERROR));
          reject(err);
        })
        .catch((err) => {
          dispatch(setOperationStatus('nursePractitioner', `fetchProgram-${domain}`, UI_OPERATION_STATUS_ERROR));
          reject(err);
        });
    });
  };
}

export function fetchFieldData(domain) {
  return (dispatch, getState) => {
    const state = getState();
    const API_URL = config.get('API_URL');
    const language = state.getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;
    const phases = state.getIn(['nursePractitioner', 'program', domain], Immutable.List());

    dispatch(setOperationStatus('nursePractitioner', `fetchFields-${domain}`, UI_OPERATION_STATUS_REQUEST));

    fetchFieldsForPhases()
      .then((data) => {
        dispatch(exerciseFieldsLoaded({
          domain,
          phases: data,
        }));

        dispatch(setOperationStatus('nursePractitioner', `fetchFields-${domain}`, UI_OPERATION_STATUS_SUCCESS));
      })
      .catch(() => {
        dispatch(setOperationStatus('nursePractitioner', `fetchFields-${domain}`, UI_OPERATION_STATUS_ERROR));
      });

    async function fetchFieldsForPhases() {
      const phasePromises = phases.map((phase) => {

        const exerciseIds = phase.keySeq().toJS();

        return exerciseIds.map((id) => {
          return fetchFieldsForWebform(id);
        });
      });

      return Promise.all(phasePromises.map(async (promises) => {
        return Promise.all(promises);
      }));
    }

    async function fetchFieldsForWebform(webformId) {
      const endpoint = `${PATH}/get-webform-fields/${domain}/${webformId}`;
      return new Promise((resolve, reject) => {
        fetch(endpoint, { credentials: 'include' })
          .then((response) => {
            if (!response.ok) {
              throw new Error();
            }
            return response.json();
          })
          .then((payload) => {
            const result = {
              webformId,
              domain,
              ...payload,
            };
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  };
}

export function fetchClients() {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;
    const endpoint = `${PATH}/get-clients-of-poh`;

    dispatch(setOperationStatus('nursePractitioner', 'fetchClients', UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(endpoint, { credentials: 'include' })
        .then((response) => {
          if (!response.ok) {
            throw new Error();
          }
          return response.json();
        })
        .then((payload) => {
          const clientsList = Object.values(payload);

          dispatch(clientsFetched(clientsList));
          dispatch(setOperationStatus('nursePractitioner', 'fetchClients', UI_OPERATION_STATUS_SUCCESS));
          resolve(clientsList);
        })
        .catch((err) => {
          dispatch(setOperationStatus('nursePractitioner', 'fetchClients', UI_OPERATION_STATUS_ERROR));
          reject(err);
        })
        .catch((err) => {
          dispatch(setOperationStatus('nursePractitioner', 'fetchClients', UI_OPERATION_STATUS_ERROR));
          reject(err);
        });
    });
  };
}

export function fetchClientRegistrations(domain, uid) {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;
    const endpoint = `${PATH}/get-client-daily-registrations/${domain}/${uid}`;

    dispatch(setOperationStatus('nursePractitioner', `fetchClientRegistrations-${domain}-${uid}`, UI_OPERATION_STATUS_REQUEST));

    const fetchRegistrations = (page = 0, entities = []) => new Promise((resolve, reject) => {
      fetch(`${endpoint}?page=${page}`, { credentials: 'include' })
        .then((response) => response.json())
        .then(async (data) => {
          data.entities = [...entities, ...data.entities];

          const { current_page, total_pages } = data.pager;
          const next_page = current_page + 1;

          if (next_page < total_pages) {
            data = await fetchRegistrations(next_page, data.entities);
          }

          resolve(data);
        })
        .catch((error) => { reject(error); });
    });

    return new Promise((resolve, reject) => {
      fetchRegistrations()
        .then((payload) => {
          const result = {
            uid,
            domain,
            ...payload,
          };

          dispatch(clientRegistrationsLoaded(result));
          dispatch(setOperationStatus('nursePractitioner', `fetchClientRegistrations-${domain}-${uid}`, UI_OPERATION_STATUS_SUCCESS));
          resolve(result);
        })
        .catch((err) => {
          dispatch(setOperationStatus('nursePractitioner', `fetchClientRegistrations-${domain}-${uid}`, UI_OPERATION_STATUS_ERROR));
          reject(err);
        })
        .catch((err) => {
          dispatch(setOperationStatus('nursePractitioner', `fetchClientRegistrations-${domain}-${uid}`, UI_OPERATION_STATUS_ERROR));
          reject(err);
        });
    });
  };
}

export function fetchClientExercises(domain, uid) {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;
    const endpoint = `${PATH}/get-client-exercises/${domain}/${uid}`;

    dispatch(setOperationStatus('nursePractitioner', `fetchClientExercises-${domain}-${uid}`, UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(endpoint, { credentials: 'include' })
        .then((response) => {
          if (!response.ok) {
            throw new Error();
          }
          return response.json();
        })
        .then((payload) => {
          const result = {
            uid,
            domain,
            ...payload,
          };

          dispatch(clientExercisesLoaded(result));
          dispatch(setOperationStatus('nursePractitioner', `fetchClientExercises-${domain}-${uid}`, UI_OPERATION_STATUS_SUCCESS));
          resolve(payload);
        })
        .catch((err) => {
          dispatch(setOperationStatus('nursePractitioner', `fetchClientExercises-${domain}-${uid}`, UI_OPERATION_STATUS_ERROR));
          reject(err);
        })
        .catch((err) => {
          dispatch(setOperationStatus('nursePractitioner', `fetchClientExercises-${domain}-${uid}`, UI_OPERATION_STATUS_ERROR));
          reject(err);
        });
    });
  };
}
